module.exports = __webpack_public_path__ + "static/media/1_en.0fa96627.png";